module.exports = __webpack_public_path__ + "img/palmar-room-5.6c495dc0.jpg";